// Общая логика Turnstile для форм заявок
export const TURNSTILE_SITE_KEY = '0x4AAAAAADmgcZZb-HUQzPgS';

export default {
    data() {
        return {
            turnstileToken: null,
            turnstileWidgetId: null,
            turnstileVisible: false,
            turnstilePendingCb: null,
        };
    },
    mounted() {
        // скрипт грузим один раз на страницу (даже если форм несколько)
        if (window.turnstile || document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) return;
        const s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        s.defer = true;
        document.head.appendChild(s);
    },
    beforeUnmount() {
        if (window.turnstile && this.turnstileWidgetId !== null) {
            window.turnstile.remove(this.turnstileWidgetId);
        }
    },
    methods: {
        // показывает капчу и после получения токена вызывает cb
        withTurnstile(cb) {
            this.turnstileVisible = true;
            this.$nextTick(() => {
                if (this.turnstileToken) { cb(); return; }
                this.turnstilePendingCb = cb;
                this.renderTurnstile();
            });
        },
        renderTurnstile() {
            const tryRender = () => {
                if (!window.turnstile || !this.$refs.turnstileContainer) return;
                if (this.turnstileWidgetId !== null) {
                    window.turnstile.reset(this.turnstileWidgetId);
                    return;
                }
                this.turnstileWidgetId = window.turnstile.render(this.$refs.turnstileContainer, {
                    sitekey: TURNSTILE_SITE_KEY,
                    theme: 'light',
                    callback: (token) => {
                        this.turnstileToken = token;
                        if (this.turnstilePendingCb) {
                            const cb = this.turnstilePendingCb;
                            this.turnstilePendingCb = null;
                            cb();
                        }
                    },
                    'expired-callback': () => { this.turnstileToken = null; },
                    'error-callback': () => { this.turnstileToken = null; },
                });
            };
            if (window.turnstile) { tryRender(); return; }
            const timer = setInterval(() => {
                if (window.turnstile) { clearInterval(timer); tryRender(); }
            }, 100);
        },
        resetTurnstile() {
            if (window.turnstile && this.turnstileWidgetId !== null) {
                window.turnstile.reset(this.turnstileWidgetId);
            }
            this.turnstileToken = null;
            this.turnstilePendingCb = null;
        },
    },
};